// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Lazy Section Wrapper Styles */
.r1Q35foGJeDz1v6pV5rs {
  position: relative;
  width: 100%;
}
.XD4CFOQ6bV9vT2UB8XXD {
  animation: urQDt39HJ6yza1bmlI1H 0.4s ease-out;
  /* backwards, not both: a held end state keeps a compositor layer per section. */
  animation-fill-mode: backwards;
  isolation: isolate;
}
/* Smooth fade and slide up animation */
@keyframes urQDt39HJ6yza1bmlI1H {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
/* Reduce motion for accessibility */
@media (prefers-reduced-motion: reduce) {
  .XD4CFOQ6bV9vT2UB8XXD {
    animation: none;
    opacity: 1;
    transform: none;
    isolation: auto;
  }
}
/* Optional: Skeleton loading effect for placeholder */
.RqsVa7ZJbGoJOl2qEXaW {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent;
  pointer-events: none;
}
/* Performance optimization for mobile */
@media (max-width: 768px) {
  .XD4CFOQ6bV9vT2UB8XXD {
    animation-duration: 0.3s;
    /* Slightly faster on mobile */
  }
}
/* Disable animations for sections that are preloaded */
.XD4CFOQ6bV9vT2UB8XXD.BLOBP6tOgiV4MZFQ3JyH {
  animation: none;
  isolation: auto;
}
`, "",{"version":3,"sources":["webpack://./src/features/sections/components/LazySectionWrapper.module.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,6CAAoC;EACpC,gFAAgF;EAChF,8BAA8B;EAC9B,kBAAkB;AACpB;AACA,uCAAuC;AACvC;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;AACA,oCAAoC;AACpC;EACE;IACE,eAAe;IACf,UAAU;IACV,eAAe;IACf,eAAe;EACjB;AACF;AACA,sDAAsD;AACtD;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,oBAAoB;AACtB;AACA,wCAAwC;AACxC;EACE;IACE,wBAAwB;IACxB,8BAA8B;EAChC;AACF;AACA,uDAAuD;AACvD;EACE,eAAe;EACf,eAAe;AACjB","sourcesContent":["/* Lazy Section Wrapper Styles */\n.sectionPlaceholder {\n  position: relative;\n  width: 100%;\n}\n.sectionContent {\n  animation: fadeSlideUp 0.4s ease-out;\n  /* backwards, not both: a held end state keeps a compositor layer per section. */\n  animation-fill-mode: backwards;\n  isolation: isolate;\n}\n/* Smooth fade and slide up animation */\n@keyframes fadeSlideUp {\n  0% {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n/* Reduce motion for accessibility */\n@media (prefers-reduced-motion: reduce) {\n  .sectionContent {\n    animation: none;\n    opacity: 1;\n    transform: none;\n    isolation: auto;\n  }\n}\n/* Optional: Skeleton loading effect for placeholder */\n.loadingPlaceholder {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: transparent;\n  pointer-events: none;\n}\n/* Performance optimization for mobile */\n@media (max-width: 768px) {\n  .sectionContent {\n    animation-duration: 0.3s;\n    /* Slightly faster on mobile */\n  }\n}\n/* Disable animations for sections that are preloaded */\n.sectionContent.preloaded {\n  animation: none;\n  isolation: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sectionPlaceholder": `r1Q35foGJeDz1v6pV5rs`,
	"sectionContent": `XD4CFOQ6bV9vT2UB8XXD`,
	"fadeSlideUp": `urQDt39HJ6yza1bmlI1H`,
	"loadingPlaceholder": `RqsVa7ZJbGoJOl2qEXaW`,
	"preloaded": `BLOBP6tOgiV4MZFQ3JyH`
};
export default ___CSS_LOADER_EXPORT___;
